/* eslint-disable */
import React, { useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import applicationStagesLabels from "../labels/applicationstages_en.json";
import "../../styles/application_management.css";
import "../../styles/time_table_management.css";

const ObjectionReport = () => {
    const pdfRef = useRef(null);
    const { getObjectionReportDetails } = useSelector((state) => state.applicationManagementReducer, shallowEqual);
    return (
        <div>
            <div className="flex-center position-ref" id="pdf-content" ref={pdfRef} >
                <div className='content'>
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <label className="f14"> <span className="fw-bold">{applicationStagesLabels.EXAMINATION_NAME}</span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.examinationName ? getObjectionReportDetails.objectionRequestReportDto.examinationName : ""} </label>
                            </div>
                            <div className="col-10">
                                <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.SUBJECT} </span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.subjectName ? getObjectionReportDetails.objectionRequestReportDto.subjectName : ""}</label>
                            </div>
                            <div className="col-2">
                                <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.QuestionNo} </span>: {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.questionNumber ? getObjectionReportDetails.objectionRequestReportDto.questionNumber : ""} </label>
                            </div>
                            <div className="col-12">
                                <label className="fw-bold f16">{applicationStagesLabels.QUESTION}</label>
                            </div>
                        </div>
                        <hr className="custom-border" />
                        <img
                            src={getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.objectionQuestionFile ? `data:image/png;base64, ${getObjectionReportDetails.objectionRequestReportDto.objectionQuestionFile}` : ""}
                            className='w-100 h-100 mt-1'
                            alt=""
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="image"
                        />
                        <label className="fw-bold f16 mb-1">{applicationStagesLabels.CANDIDATE_OBJECTION}</label>
                        {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList && getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList.length > 0 ?
                            <div id="table-container">
                                <table className="table mt-1 table-style">
                                    <thead>
                                        <tr>
                                            {applicationStagesLabels.ObjectionReportHeaders.map((ele, index) =>
                                                <th scope="col" key={index} className="f12 text-center border border-dark theadBgColor">{ele}</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList && getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList.length > 0 && getObjectionReportDetails.objectionRequestReportDto.objectionRequestsList.map((ele, i) => {
                                            if (ele) {
                                                return (
                                                    <tr>
                                                        <td className="word-break f12 w3 text-center border border-dark">{i + 1}</td>
                                                        <td className="word-break f12 w18 border border-dark"> {ele.applicationNo ? ele.applicationNo : "-"} </td>
                                                        <td className="word-break f12 w10 border border-dark"> {ele.examSubjectName ? ele.examSubjectName : "-"} </td>
                                                        <td className="word-break f12 w3 text-center border border-dark"> {ele.masterQuestionSrno ? ele.masterQuestionSrno : "-"} </td>
                                                        <td className="word-break f12 w3 text-center border border-dark"> {ele.masterKeyAnswer ? ele.masterKeyAnswer : "-"} </td>
                                                        <td className="word-break f12 w3 text-center border border-dark"> {ele.candidateAnswer ? ele.candidateAnswer : "-"} </td>
                                                        <td className="word-break f12 border border-dark"> {ele.objectionRemark ? ele.objectionRemark : "-"} </td>
                                                        <td className="word-break f12 w10 border border-dark"> {ele.referenceBook ? ele.referenceBook : "-"} </td>
                                                        <td className="word-break f12 w10 border border-dark"> {ele.authorName ? ele.authorName : "-"} </td>
                                                        <td className="word-break f12 w10 border border-dark"> {ele.referenceDocument ? ele.referenceDocument : "-"} </td>
                                                    </tr>
                                                )
                                            }
                                        })}

                                    </tbody>
                                </table>
                            </div>
                            : ""
                        }
                    </div>
                </div>
            </div>
            <div className="new-page">
                <div>
                    <div className="row">
                        <div className="col-12">
                            <label className="f14"> <span className="fw-bold">{applicationStagesLabels.EXAMINATION_NAME}</span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.examinationName ? getObjectionReportDetails.objectionRequestReportDto.examinationName : ""} </label>
                        </div>
                        <div className="col-10">
                            <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.SUBJECT} </span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.subjectName ? getObjectionReportDetails.objectionRequestReportDto.subjectName : ""}</label>
                        </div>
                        <div className="col-2">
                            <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.QuestionNo} </span>: {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.questionNumber ? getObjectionReportDetails.objectionRequestReportDto.questionNumber : ""} </label>
                        </div>
                    </div>
                    <table className="custom-style">
                        <tbody>
                            <tr className="h-70">
                                <td className="fw-bold f14 p-3 align-top border border-dark">
                                    {applicationStagesLabels.EXPERTS_OPINION}
                                </td>
                            </tr>

                            <tr className="custom-height">
                                <td className="fw-bold f14 p-3 align-top border border-dark">
                                    {applicationStagesLabels.OFFICE_NOTE}
                                </td>
                            </tr>

                            <tr className="custom-height">
                                <td className="fw-bold f14 p-3 align-top border border-dark">
                                    {applicationStagesLabels.HON_SECRETARYS_OPINION}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="new-page">
                <div>
                    <div className="row">
                        <div className="col-12">
                            <label className="f14"> <span className="fw-bold">{applicationStagesLabels.EXAMINATION_NAME}</span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.examinationName ? getObjectionReportDetails.objectionRequestReportDto.examinationName : ""} </label>
                        </div>
                        <div className="col-10">
                            <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.SUBJECT} </span> {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.subjectName ? getObjectionReportDetails.objectionRequestReportDto.subjectName : ""}</label>
                        </div>
                        <div className="col-2">
                            <label className="f14"> <span className="fw-bold"> {applicationStagesLabels.QuestionNo} </span>: {getObjectionReportDetails && getObjectionReportDetails.objectionRequestReportDto && getObjectionReportDetails.objectionRequestReportDto.questionNumber ? getObjectionReportDetails.objectionRequestReportDto.questionNumber : ""} </label>
                        </div>
                    </div>
                    <table className="w-100 h100">
                        <tbody>
                            <tr>
                                <td className="fw-bold f14 p-3 align-top border border-dark">
                                    {applicationStagesLabels.HON_CHAIRMANS_ORDER}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
};
export default ObjectionReport;